import Vue from 'vue';
import VueRouter from 'vue-router';
import {routers} from './router';
import iView from 'iview';
import Util from '../lib/util';
import Cookies from 'js-cookie'
import { appRouters,otherRouters} from './router'

Vue.use(VueRouter);

const RouterConfig = {
    // mode: 'history',
    routes: routers
};

export const router = new VueRouter(RouterConfig);

router.beforeEach((to, from, next) => {
    iView.LoadingBar.start();
    if (to && to.path && to.path.indexOf("success/&shop_id=") != -1) {
        var shopid = abp.getQueryVariable("shop_id");
        var code = abp.getQueryVariable("code");
        var str1 = code.substring(0, code.indexOf("#"));
        var host = window.location.host+"#";
        var url = "http://"+ host + "/frontauthorization/success/?" + "code=" + str1 + "&" + "shop_id=" + shopid;
        //window.location.href ="http://localhost:1337/#/frontauthorization/success/?code=1f12991ca6cd0ec3ef6a1b893f554b18&shop_id=170977925";
        window.location.href = url;
    }
    Util.title(to.meta.title);
    if (Cookies.get('locking') === '1' && to.name !== 'locking') {
        next({
            replace: true,
            name: 'locking'
        });
    }else if (Cookies.get('locking') === '0' && to.name === 'locking') {
        next(false);
    } else {
        if (!Util.abp.session.userId&& to.name !== 'login') {
            next({
                name: 'login'
            });
        } else if (!!Util.abp.session.userId && to.name === 'login') {
            Util.title(to.meta.title);
            next({
                name: 'home'
            });
        } else {

            // ����Ƿ����ƶ�����ӵ�вֿ���Ȩ��
            const isMobile = abp.isMobile();
            const hasStockPermission = window.abp.auth.hasPermission('warehouse.Stock');
            const permissionRequiredRoutes = ["uploadpackageimg", "logisticsphoto", "abnormalphoto", "outboundconfirm", "packconfirm", "backhome", "BackStockBatchH5", "BackStockPickH5","BackStockPickNewH5"];
            // ������ƶ���
            if (isMobile) {
                // ���1����Ȩ�ޣ������ʵĲ���Ȩ�޲˵�ҳ��
                if (hasStockPermission && !permissionRequiredRoutes.includes(to.name)) {
                    // Ĭ����ת��backhome
                    next({
                        replace: true,
                        name: 'backhome'
                    });
                    return;
                }

                // ���2��ûȨ�ޣ�ȴ���Է�����ҪȨ�޵�ҳ��
                if (!hasStockPermission && permissionRequiredRoutes.includes(to.name)) {
                    // ��ת��home
                    next({
                        replace: true,
                        name: 'home'
                    });
                    return;
                }
            }




            const curRouterObj = Util.getRouterObjByName([otherRouters, ...appRouters], to.name);
            if (curRouterObj && curRouterObj.permission) {
                if (window.abp.auth.hasPermission(curRouterObj.permission)) {
                    Util.toDefaultPage([otherRouters, ...appRouters], to.name, router, next);
                } else {
                    next({
                        replace: true,
                        name: 'error-403'
                    });
                }
            } else {
                Util.toDefaultPage([...routers], to.name, router, next);
            }
        }
    }
});
router.afterEach((to) => {
    Util.openNewPage(router.app, to.name, to.params, to.query);
    iView.LoadingBar.finish();
    window.scrollTo(0, 0);
});